'use client';

import { twMerge } from 'tailwind-merge';
import { Box, GridLayout, Typography } from '@wishket/design-system';

import NewsletterSubscriptionCompleteDialog from '../NewsletterSubscriptionCompleteDialog';

import { backgroundGradientSvgString } from './backgroundGradientSvg';

import { Icon } from '@/shared/Components';
import { useAuth, useNewsLetterSubscription } from '@/shared/hooks';
import NewsletterBannerInput from '@/features/NewsletterBannerInput';

const NewsletterSubscriptionBanner = () => {
  const {
    isPending,
    information,
    isCheckBoxError,
    emailErrorMessage,
    isCompleteDialogOpen,
    currentSubscriptionCount,
    onSubmit,
    onChange,
    onClickMore,
    MarketingInfoModal,
    onCompletedDialogClose,
  } = useNewsLetterSubscription();
  const { isAuth } = useAuth();

  if (isAuth) return <></>;

  return (
    <>
      <Box
        data-testid="newsletter-subscription-banner"
        className="bg-cover bg-center"
        style={{
          backgroundImage: `url("data:image/svg+xml;utf8,${encodeURIComponent(backgroundGradientSvgString)}")`,
        }}
      >
        <GridLayout>
          <Box className="flex gap-6 py-[60px] grid-in-content desktop:py-[100px]">
            <Box className="flex w-full flex-col gap-6 desktop:flex-row">
              <Box className="flex flex-1 flex-col gap-4 desktop:gap-6">
                <Typography
                  variant="subTitle1"
                  className={twMerge(
                    'whitespace-pre-line font-bold text-w-gray-900',
                    // TODO: 디자인시스템 typography에 title2.5추가이후 아래 28px 변경
                    'tablet:whitespace-normal desktop:whitespace-pre-line desktop:text-[28px] desktop:leading-10'
                  )}
                >
                  {'에디터가 직접 고른 실무 인사이트\n매주 목요일에 만나요.'}
                </Typography>
                <Box className="flex items-center gap-4">
                  <Icon name="newsletter_profile" />
                  <Typography
                    variant="body1"
                    className="text-w-gray-600"
                  >{`${currentSubscriptionCount.toLocaleString()}명 뉴스레터 구독 중`}</Typography>
                </Box>
              </Box>
              <form
                onSubmit={onSubmit}
                className="flex flex-1 flex-col gap-8 desktop:w-[556px] desktop:flex-row desktop:gap-4"
              >
                <NewsletterBannerInput
                  isPending={isPending}
                  information={information}
                  isCheckBoxError={isCheckBoxError}
                  emailErrorMessage={emailErrorMessage}
                  onChange={onChange}
                  onClickMore={onClickMore}
                />
              </form>
            </Box>
          </Box>
        </GridLayout>
      </Box>
      <NewsletterSubscriptionCompleteDialog
        email={information.email}
        isOpen={isCompleteDialogOpen}
        onClose={onCompletedDialogClose}
      />
      <MarketingInfoModal />
    </>
  );
};

export default NewsletterSubscriptionBanner;
